import CustomInput from '../../components/inputs/CustomInputs';
import { Box, Grid, Typography, useMediaQuery } from '@mui/material';
import OneViewBox from '../../components/layouts/OneViewBox';
import BgGradient from '../../components/layouts/auth/BgGradient';
import CustomContainer from '../../components/layouts/CustomContainer';
import AuthLeftContainer from '../../components/layouts/auth/AuthLeftContainer';
import AuthRighttContainer from '../../components/layouts/auth/AuthRightContainer';
import SignInButton from '../../components/button/SignInButton';

const SignInUI = ({ state, setState, onSubmit, loading }) => {
    const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down("md"))

    return (

        <>
            <OneViewBox sx={{ overflow: "hidden" }}  >
                <BgGradient left={true} />
                <BgGradient />
                {!isSmallScreen && <Box mt={7} mb={5}></Box>}
                <CustomContainer sx={{ marginBottom: "100px" }}>
                    <Grid container spacing={2} sx={{ display: "flex" }}>
                        <Grid item xs={12} md={6}>
                            <AuthLeftContainer />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <AuthRighttContainer >
                                <Box component={"form"} width={"100%"} onSubmit={onSubmit}>

                                    <Typography variant="h2" mb={2}>
                                        Sign In
                                    </Typography>
                                    <Typography variant="h4" color={"red"} mb={1}>
                                        {state.err}
                                    </Typography>
                                    <Box  >
                                        <Box mb={3}     >

                                            <CustomInput
                                                disabled={loading}
                                                value={state.email}
                                                onChange={(e) => setState({ ...state, err: '', email: e.target.value })}
                                                type="text"
                                                label={"Email"}
                                            />
                                        </Box>
                                        <CustomInput
                                            disabled={loading}
                                            value={state.password}
                                            onChange={(e) => setState({ ...state, err: '', password: e.target.value })}
                                            type="password"
                                            label={"Password"}
                                        />

                                    </Box>
                                    <Box mt={4}>
                                        <SignInButton loading={loading} disabled={loading} type='submit' title='Sign In' />
                                    </Box>

                                </Box>
                            </AuthRighttContainer>
                        </Grid>
                    </Grid>




                </CustomContainer>
            </OneViewBox>


        </>
    )
}
export default SignInUI

